/*
    Explanation of regex:
    (https?:\/\/.)? : matches optionally http:// or https://
    [-a-zA-Z0-9@:%._\\+~#?&//=]{1,256} : 1-256 alphanumeric characters and/or special characters. The first instance of this set represents the set of characters to allow in the sub-domain and domain part. While the second instance of this set represents the set of characters to allow in the query string or subdirectory part.
    \. : "." character
    [a-z]{2,6} : any lowercase letters from a to z with a length between two and six. This represents the set of characters to allow in the top-level domain part.
    \b : the boundary of a word, i.e. the start of a word or the end of one.
    ([-a-zA-Z0-9@:%_\+.~#?&//=]*) : * times a character from the list to indicate zero or more copies of the query string, parameters or subdirectories
*/
export const URL_OPTIONAL_HTTP_REGEX =
    /^(https?:\/\/.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/
